import { render, staticRenderFns } from "./FundNavDocuments.vue?vue&type=template&id=4b47acb6"
import script from "./FundNavDocuments.vue?vue&type=script&lang=js"
export * from "./FundNavDocuments.vue?vue&type=script&lang=js"
import style0 from "./FundNavDocuments.vue?vue&type=style&index=0&id=4b47acb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports